import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import { withRouter } from 'components/withRouter';

class ManageEmployees extends Component {
    static displayName = ManageEmployees.name;

    static employeeSchema;
    static employeeModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    constructor(props) {
        super(props);

        this.employeeGen = React.createRef(null);

        this.state = { employees: [], curEmployee: null, curEmployeeId: 0, status: [], defaultStatus: 1000, curStatus: 1000/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1", title: props.i18nManager.t("employee.noSelected"), editionMode: false };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/employee/GetEmployeeModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.employeeModels = {};
                    dataModels.result.models.forEach((model) => {
                        context.employeeModels[model.extID] = JSON.parse(model.value);
                    });

                    /*commonFunc.getMethod("../api/employee/GetSchemaModel", null).then((response) => {
                        var dataSchema = response.data
                        if (dataSchema.isSuccess) {

                            context.employeeSchema = dataSchema.result;*/

                            //Chargement via url
                            var defEmployeeLoadId = 0;
                            var defEmployeeActionId = 0;
                            if (context.props.searchParams) {
                                defEmployeeLoadId = parseInt(context.props.searchParams.get("employeeId")) || 0;
                                defEmployeeActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                            }
                            if (defEmployeeLoadId > 0) {
                                var defEmployeeStatusId = parseInt(context.props.searchParams.get("statusId")) || 1000;

                                context.loadStatusBtnGrp(defEmployeeStatusId);

                                context.getEmployees(defEmployeeStatusId, false, function () {
                                    if (context) {
                                        context.loadReportCb = () => {
                                            if (defEmployeeActionId) context.switchTab(defEmployeeActionId.toString());

                                            //setTimeout(function () {
                                            var element = document.querySelector('.tableContainer');
                                            const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                            context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                            //}, 2000);
                                        };
                                    }
                                    showDtSelID("tableEmployees", defEmployeeLoadId);
                                });
                            } else {
                                context.loadStatusBtnGrp(1000);

                                context.getEmployees();

                                if (defEmployeeActionId) context.switchTab(defEmployeeActionId.toString());

                                /*if (defEmployeeActionId == 1) {
                                    $(".action-addReport:visible").click();
                                }*/
                            }

                        /*}
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de la récupération du schéma employé"
                            });
                        }
                    });*/
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports ||*/ prevState.curStatus !== this.state.curStatus) {
            this.getEmployees();
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateEmployee
        if (this.state.curEmployeeId === 0 /*&& prevState.curEmployeeId !== this.state.curEmployeeId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableEmployees"]) this.dtFunctions["tableEmployees"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;
        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadEmployee(rowData.idEmployee, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idEmployee;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadEmployee(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadEmployee();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.employeeModels ? <CDataTable key="employees" dtId={"tableEmployees"} data={this.state.employees} localConfig={dtConfig} tag={"DT_SALS"} config={this.employeeModels["DT_SALS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;

        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("employee.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getEmployees()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {this.props.checkRights("EMPLOYEE", "C") ? <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateEmployee()}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("employee.add")}
                            </Button> : ""}
                        </div>
                        <CNavbar className="float-end">
                            <div className="text-end">
                                {this.state.status.map((dt) => {

                                    //TODO : statusBtnAltProc

                                    var statusClass = "form-badge-radio mb-1 ";
                                    statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                    return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                        <div className='form-check-radio fcheck-sm mb-0'>
                                            <Label check >
                                                <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                    var value = parseInt(e.target.value);

                                                    context.setState({ curStatus: value, curEmployeeId: 0, curEmployee: null, isShowDetails: false });
                                                }} />
                                                <span className="form-check-sign" />
                                                {(() => {
                                                    var classFa = "";
                                                    if (dt.css && dt.css.indexOf("fa-")) {
                                                        dt.css.split(" ").forEach((classElem) => {
                                                            //console.debug(classElem.startsWith("fa-") + classElem);
                                                            classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                        });
                                                    }
                                                    return <i className={`fa ${classFa} me-1`}></i>
                                                })()}
                                                {altT(dt.name)}
                                            </Label>
                                        </div>
                                    </div> : "";
                                })}
                            </div>
                        </CNavbar>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curEmployeeId || 0;
                                        showDtPrevID("tableEmployees", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curEmployeeId || 0;
                                        showDtNextID("tableEmployees", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {this.props.checkRights("EMPLOYEE", "R") ? <NavItem><NavLink className={`${this.state.activeTab === '1' ? "active" : ""}`} onClick={() => { this.switchTab("1") }}>{context.props.i18nManager.t("employee.tabDetails")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("EMPLOYEE_CONTRACTS", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '6' ? "active" : ""}`} onClick={() => { this.switchTab("6") }}>{context.props.i18nManager.t("employee.tabContracts")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("EMPLOYEE_FILES", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '3' ? "active" : ""}`} onClick={() => { this.switchTab("3") }}>{context.props.i18nManager.t("employee.tabDocs")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("EMPLOYEE_EVENTS", "L") ? <NavItem className="d-none"><NavLink className={`${this.state.activeTab === '4' ? "active" : ""}`} onClick={() => { this.switchTab("4") }}>{context.props.i18nManager.t("employee.tabItvs")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("EMPLOYEE_CONTACTS", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '2' ? "active" : ""}`} onClick={() => { this.switchTab("2") }}>{context.props.i18nManager.t("employee.tabContacts")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("EMPLOYEE_FLOWS", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '5' ? "active" : ""}`} onClick={() => { this.switchTab("5") }}>{context.props.i18nManager.t("employee.tabFlows")}</NavLink></NavItem> : ""}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {this.props.checkRights("EMPLOYEE", "R") ? <TabPane tabId="1">
                            <ShowDetails id={this.state.curEmployeeId} type="employee" genRef={this.employeeGen} data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["EMPLOYEE"] : {}} modelsList={this.employeeModels} loadElem={this.loadEmployee.bind(this)} saveElem={this.saveEmployee.bind(this)} removeElem={this.removeEmployee.bind(this)} updateStatusElem={this.updateEmployeeStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === '1'} />
                        </TabPane> : ""}
                        {this.props.checkRights("EMPLOYEE_CONTRACTS", "L") ? <TabPane tabId="6">
                            <ShowDetails id={this.state.curEmployeeId} type="employeeContracts" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["CONTRACTS"] : {}} modelsList={this.employeeModels} shouldRender={this.state.activeTab === '6'} />
                        </TabPane> : ""}
                        {this.props.checkRights("EMPLOYEE_FILES", "L") ? <TabPane id="aupdAct-3" tabId="3">
                            <Form id="frmaupdact3">
                                <FilesCustom className="employee-files" bindID={this.state.curEmployeeId} rightType="EMPLOYEE_FILES" checkRights={this.props.checkRights} fileTypeID="EMPLOYEE" src={this.state.curEmployee} srcName={this.state.curEmployee ? this.state.curEmployee.name : ""} withFilters={true} shouldRender={this.state.activeTab === '3'} defaultFileType={"EGL"} altFilesTypes="../api/employee/GetEmployeeFilesType" altFilesUrl="../api/employee/GetEmployeeFiles" altRemoveFilesUrl="../api/employee/RemoveEmployeeFile" altUploadFilesUrl="../api/employee/UploadEmployeeFiles" />
                            </Form>
                        </TabPane> : ""}
                        {this.props.checkRights("EMPLOYEE_EVENTS", "L") ? <TabPane tabId="4">
                            <ShowDetails id={this.state.curEmployeeId} type="employeeItvs" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["ITVS"] : {}} modelsList={this.employeeModels} loadElem={this.loadEmployee.bind(this)} shouldRender={this.state.activeTab === '4'} />
                        </TabPane> : ""}
                        {this.props.checkRights("EMPLOYEE_CONTACTS", "L") ? <TabPane tabId="2">
                            <ShowDetails id={this.state.curEmployeeId} type="employeeContacts" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["CONTACTS"] : {}} modelsList={this.employeeModels} shouldRender={this.state.activeTab === '2'} />
                        </TabPane> : ""}
                        {this.props.checkRights("EMPLOYEE_FLOWS", "L") ? <TabPane tabId="5">
                            <Row className="employee-history">
                                <Col lg="12">
                                    <Card className="widget dash">
                                        <CardHeader>
                                            <CardTitle tag="h6">{context.props.i18nManager.t("employee.flowsTitle")}</CardTitle>
                                            <div className="widget-tools collapse-tool">
                                                <i className="fa fa-history fa-4x"></i>
                                            </div>
                                            <div className='borderTheme'></div>
                                        </CardHeader>
                                        <CardBody>
                                            <Historical type="employee" elemId={context.state.curEmployeeId} url="../api/employee/GetEmployeeFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === '5'} />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </TabPane> : ""}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    async getEmployees(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ employees: [], curEmployeeId: 0, curEmployee: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus || 1000;

        commonFunc.getMethod("../api/employee/GetEmployees", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {

                    /*$('#lstActs thead th').each(function () {
                        var title = $(this).text();
                        if ($(this).hasClass("searchable")) {
                            $(this).append('<input type="text" class="form-control col-lg-12 form-control-sm" placeholder="' + title + '" />');
                        }
                    });*/

                    Swal.close();
                    context.setState({ employees: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("employee.failLoadEmployees") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("employee.failLoadEmployees")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/employee/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadEmployee(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("employee.noSelected"), curEmployeeId: 0, curEmployee: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            args.level = 2;
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                commonFunc.getMethod("../api/employee/GetEmployee", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (data.result?.contracts?.length) {
                            var contractSiteIDs = [];
                            data.result.cContractSites = data.result.contracts.map(contract => {
                                if (contractSiteIDs.indexOf(contract.siteID) < 0) {
                                    contractSiteIDs.push(contract.siteID);
                                    return contract.siteID;
                                }
                                else {
                                    return null;
                                }
                            }).filter((elem => elem != null)).join(";");
                        }

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        //data.result.trigram
                        if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.name + " " + data.result.firstName), curEmployeeId: id, curEmployee: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("employee.failLoadEmployee") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async saveEmployee(userEmployee, isUpdate) {
        var context = this;
        const dataEmployee = this.state.curEmployee || {};

        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });


        if (!userEmployee.avoidMerge) {
            userEmployee = commonFunc.mergeDeep({}, dataEmployee, userEmployee);

            userEmployee.contacts = [];//???
            //userEmployee.contracts = [];
            userEmployee.employeeFiles = [];
            userEmployee.employeeParents = [];
            userEmployee.flows = [];
            userEmployee.skillsAssigned = [];//???
            userEmployee.models = [];

            userEmployee.accountUser = null;
            userEmployee.agencySite = null;
            userEmployee.category = null;
            userEmployee.parent = null;
            userEmployee.group = null;
            userEmployee.site = null;
            userEmployee.extraSite = null;
            userEmployee.status = null;
            userEmployee.subStatus = null;
            userEmployee.tenantUserAccess = null;
        }

        if (userEmployee.contract) {//userEmployee.cContractSites
            var sites = userEmployee.cContractSites.split(";");
            var conservedContractSites = [];
            var oldContracts = dataEmployee.contracts;
            userEmployee.contracts = [];
            sites.forEach((siteContract) => {
                if (!commonFunc.isBlank(siteContract)) {
                    var findOldContract = oldContracts?.filter((contract) => contract.siteID === parseInt(siteContract));

                    var newContract = {};
                    if (isUpdate && findOldContract?.length) {
                        findOldContract.forEach((contract) => {
                            newContract = contract;
                            conservedContractSites.push(newContract.siteID);
                            newContract = Object.assign(newContract, userEmployee.contract);
                            newContract.employeeID = userEmployee.idEmployee;
                            newContract.siteID = parseInt(siteContract);
                            userEmployee.contracts.push(newContract);
                        });
                    }
                    else {
                        newContract.idContract = 0;
                        newContract = Object.assign(newContract, userEmployee.contract);
                        newContract.employeeID = userEmployee.idEmployee;
                        newContract.siteID = parseInt(siteContract);
                        userEmployee.contracts.push(newContract);
                    }
                }
            });
            userEmployee.contract = null;
            userEmployee.cContractSites = null;

            //Suppression des contrats
            if (isUpdate && oldContracts?.length && conservedContractSites?.length < oldContracts?.length) {
                oldContracts.forEach((oldContract) => {
                    if (conservedContractSites.indexOf(oldContract.siteID) < 0) {
                        commonFunc.postMethod("../api/employee/RemoveEmployeeContract", { isPermanent: true, id: oldContract.idContract, bindId: userEmployee.idEmployee });
                    }
                });
            }
        }
        else {
            userEmployee.contracts = [];
        }

        console.debug(userEmployee);
        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
        return commonFunc.postMethod(isUpdate ? "../api/employee/UpdateEmployee" : "../api/employee/CreateEmployee", userEmployee).then((response) => {
            Swal.close();
            return new Promise((resolve, reject) => {
                var data = response.data;
                if (data && data.isSuccess) {
                    Swal.fire({
                        icon: "success",
                        title: context.props.i18nManager.t("gal_success"),
                        html: (isUpdate ? context.props.i18nManager.t("gal_successUpd") : context.props.i18nManager.t("gal_successAdd")),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        /*context.getEmployees(0, true, () => {
                            showDtSelID("tableEmployees", data.result.idEmployee);
                        });*/
                        context.loadEmployee(data.result.idEmployee);//userEmployee.idEmployee
                    });

                    data.result.idResponse = data.result.idEmployee;
                    resolve(data.result);

                } else {
                    var supErrors = "";
                    if (data.errors && data.errors.length) {
                        supErrors = data.errors.map((error) => {
                            return "<br>" + error.desc + "(" + error.value + ")";
                        });
                    }
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                    });
                    resolve(data);
                }
            });
        });
    }

    removeEmployee(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curEmployee;
            if ((!id && row) || (id && row && id === row.idEmployee)) {
                id = id || row.idEmployee;
                title = row.name + " " + row.firstName;
            }
            if (parseInt(id) > 0) {
                if (row.accountID > 0 && row.accountUser?.isActive) {
                    Swal.fire({
                        icon: "warning",
                        title: context.props.i18nManager.t("gal_rmvTitle"),
                        html: context.props.i18nManager.t("gal_rmvAccWarn")
                    });
                }
                else {
                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("gal_removing"),
                        html: context.props.i18nManager.t("employee.rmvTitle") + "<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("employee.removing"),
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, isPermanent: false };
                            commonFunc.postMethod("../api/employee/RemoveEmployee", req).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    context.getEmployees();//TODO : check si besoin de refresh supplémentaire
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(data);
                            });

                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateEmployeeStatus(statusId, stepId, customLabel) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curEmployeeId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadEmployee = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("employee.updStatus"),
                        html: context.props.i18nManager.t("employee.statusAs", [label]),
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("employee.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                            var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                            commonFunc.postMethod("../api/employee/UpdateStatus", req).then((response) => {

                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    //if (reloadEmployee) context.loadEmployee(id);
                                    //context.getEmployees();//TODO : check si besoin de refresh supplémentaire
                                    /*context.getEmployees(0, true, () => {
                                        if (reloadEmployee) showDtSelID("tableEmployees", id);
                                    });*///TODO : check si besoin de refresh supplémentaire
                                    if (reloadEmployee) context.loadEmployee(id);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    initCreateEmployee() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableEmployees");
        //this.employeeGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("employee.create"), curEmployeeId: 0, curEmployee: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curEmployee ? (this.state.curEmployee.name + " " + this.state.curEmployee.firstName) : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("employee.duplicate") : this.props.i18nManager.t("employee.edit"))  + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageEmployees));
